import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import * as React from 'react';
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    checkbox: {
        '&.Mui-checked': {
            color: "#4E9F3D",
        },
    },

}))
const CheckBox = (props) => {
    const classes = useStyles();
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{props.heading}</FormLabel>
            <FormGroup aria-label="position" row>

                <FormControlLabel
                    value={props.value}
                    control={<Checkbox className={classes.checkbox} checked={props.value}
                    />}
                    label={props.label}
                    labelPlacement={props.labelPlacement}
                    className={classes.text}
                    onChange={(e, checked) => props.onChange(checked)}
                />
            </FormGroup>
            {props.isError && <Typography variant={"caption"} color={"error"}>{props.errorMessage}</Typography>}
        </FormControl>
    );
}
CheckBox.propTypes = {
    heading: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    labelPlacement: "end" | "start",
};
CheckBox.defaultProps = {
    heading: "",
    labelPlacement: "end",
};

export default CheckBox;
